import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import { Button } from '@material-ui/core';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { InputCpf, InputPassword } from 'components';
import { Form,  OverlayTrigger, Tooltip } from 'react-bootstrap';
import Alert from '@material-ui/lab/Alert';
import apiLogin from "services/structure/apiLogin";
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import * as FontAwesome from '@fortawesome/react-fontawesome';

class LoginResetSenhaPanel extends Component {
    
    state = {
        documento: "",
        senha: "",
        confirmacaoSenha: "",
        error: "",
        success: "",
    };

    handleLogin = async e => {
        this.setState({ error : "" });
        e.preventDefault();
        const { documento, senha, confirmacaoSenha } = this.state;
        if (!documento) {
            this.setState({ error: "Preencha CPF, senha e confirmação de senha para continuar!" });
        } else if (senha !== confirmacaoSenha) {
            this.setState({ error: "A senha deve ser igual a confirmação de senha!" });
        } else {
            try {
                const response = await apiLogin.post("/user/recover-password", { cpf: documento, senha: senha});
                if (response.data.sucesso) {
                    this.setState({ success: response.data.mensagem });
                    return;
                }
                this.setState({ error: response.data.mensagem });
            } catch (err) {
                const mensagem = err.response?.data?.message ?? err.response?.data?.mensagem ?? "Houve um problema ao tentar se comunicar com o servidor. Por favor, tente novamente mais tarde. " ;
                this.setState({ error: mensagem });
            }
        }
    };

    render() {
        return (
                <Form onSubmit={this.handleLogin} className={`login-reset-senha-form ${this.props.className}`}>
                    <InputCpf 
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        label="Digite seu CPF"
                        name="documento"
                        onChange={e => this.setState({ documento: e.target.value })}
                        error={!!this.state.error}/>
                    <InputPassword
                        name="senha"
                        label="Digite sua senha"
                        onChange={e => this.setState({ senha: e.target.value })}
                        error={!!this.state.error}/>
                    <InputPassword
                        name="confirmacaoSenha"
                        label="Confirme sua senha"
                        onChange={e => this.setState({ confirmacaoSenha: e.target.value })}
                        error={!!this.state.error}/>
                    {
                        !!this.state.error &&
                        <Alert severity="error"><p>{this.state.error}</p></Alert>
                    }
                    {
                        !!this.state.success &&
                        <Alert severity="info"><p>{this.state.success}</p></Alert>
                    }
                    <div className="login-reset-senha-button-box">
                        <Button type="submit" fullWidth className={`button login-reset-senha-button ${this.props.className}`}
                            variant="contained">
                            <FontAwesome.FontAwesomeIcon icon={faUser} className={`login-button-reset-senha-icon ${this.props.className}`}/> 
                            <span className={`login-button-reset-senha-label ${this.props.className}`}>ENVIAR</span>
                        </Button>
                        <OverlayTrigger placement="bottom"
                            overlay={
                                <Tooltip className='help-button'>
                                    Você receberá a validação de acesso no e-mail vinculado ao CPF.
                                </Tooltip>
                            }>
                            <Button onClick={() => this.setState({show: !this.state.show})}
                                    className="help-button-esqueci-senha">
                                <FontAwesome.FontAwesomeIcon icon={faQuestion} className="question-icon"/>
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Form>
        )
    }
}

export default withRouter(LoginResetSenhaPanel);